import { useMemo } from "react";
import { useFlag } from "../../../server/optimizely";
import { sortTypes } from "../../create-content-card/content-type-select";
import { useMultiformat } from "../../multiformat/hooks/use-multi-format";

/**
 * The format to start the AI dialog on for a design: the first after Communication in the dialog's
 * own list. Undefined until the list loads, when the dialog starts on its usual Communication.
 */
export const useFirstDesignFormat = (): string | undefined => {
  const { data: multiformat } = useMultiformat();
  const [prototypes] = useFlag("mfai_prototypes");

  return useMemo(
    () =>
      multiformat
        ? sortTypes(multiformat, prototypes).find(({ value }) => value !== "Communication")?.value
        : undefined,
    [multiformat, prototypes],
  );
};
